/** @format */

import Decimal from "decimal.js";

export const DECIMAL_ZERO = new Decimal(0);
export const DECIMAL_ONE = new Decimal(1);
export const DECIMAL_ONE_HUNDRED = new Decimal(100);

export const formatFloorNumber = (number, flex = 0) => {
  const numberOfDecimal = 10 ** flex;
  const roundedNumber = Math.floor(number * numberOfDecimal) / numberOfDecimal;
  return new Intl.NumberFormat().format(roundedNumber.toFixed(flex));
};

/**
 *少数の０を省略するためのメソッド
 * @param decimalNumStr
 * @returns {string}
 */
export function stripTrailingZeros(decimalNumStr) {
  if(decimalNumStr === "" || decimalNumStr === 0) return "";
  return new Decimal(decimalNumStr).toString();
}